import React, { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles, useTheme } from "@mui/styles";
import { Typography, Card, useMediaQuery } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { useNavigate } from "react-router-dom";
import { theme } from "../../styles/theme";
import role from "../../redux/actions/role";
import Sections from "./Sections";
import SimpleSnackbar from "../../components/controls/ToastMessage";

const useStyles = makeStyles({
  scoreCard: {
    backgroundColor: `${theme.palette.primary.light} !important`,
    height: "100%",
  },
  scoreCard1: {
    backgroundColor: `#F8F8F8 !important`,
    height: "100%",
  },
  sectionDisable: {
    backgroundColor: `${theme.palette.black.gray} !important`,
    height: "100%",
  },
  primaryText: {
    color: theme.palette.primary.main,
    fontWeight: "500 !important",
    fontSize: "14px !important",
  },
  disablePrimaryText: {
    color: theme.palette.black.light,
    fontWeight: "500 !important",
    fontSize: "14px !important",
  },
  link: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    letterSpacing: "0em",
    textalign: "left",
    textDecoration: "none !important",
    "& .css-1ps4owl-MuiTypography-root-MuiLink-root": {
      textDecoration: "none !important",
      color: "#1789FC !important",
    },
  },
  disabledCardLink: {
    cursor: "default",
    pointerEvents: "none",
    //color: "#787878 !important",
    fontFamily: "Roboto",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    letterSpacing: "0em",
    textalign: "left",
  },
  disabledLink: {
    color: "#787878 !important",
    fontFamily: "Roboto",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    letterSpacing: "0em",
    textalign: "left",
    textDecoration: "none !important",
    // cursor: 'none',
  },
  scoresCalculatedByCardTitle: {
    marginBottom: "12px !important",
    height: "auto",
  },
  sectionTitle: {
    //marginBottom: 6,
    padding: "4px",
    // fontSize: "16px",
    // lineHeight: "24px",
    [theme.breakpoints.down("sm")]: {
      // fontSize: "24px",
      // lineHeight: "32px"
      marginBottom: 2,
      padding: "2px",
    },
  },
  grayText: {
    color: "#787878",
    fontFamily: "Roboto !important",
  },
  grayText1: {
    color: "#C4C4C4",
  },
  subTitle: {
    marginBottom: "6px",
    padding: "4px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "3px",
      padding: "3px",
    },
  },
  incompleteTxt: {
    fontWeight: "normal",
  },
  linkCursor: {
    cursor: "pointer",
  },

  roletype: {
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "500 !important",
    fontSize: "14px !important",
    lineHeight: "24px !important",
    color: " #787878",
    // textAlign:'center',
    paddingTop: "0px",
  },
  sectionMainContainer: {
    display: "flex",
    flexWrap: "wrap",
  },

  sectionChildContainer: {
    display: "flex",
    alignItems: "end",
    margin: "10px",
  },

  roundedCircle: {
    marginBottom: "9px",
    display: "inline-block",
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    border: "1px solid #C4C4C4",
  },

  roundedText: {
    color: "#787878",
    padding: "5px",
    display: "block",
  },
  textSty: theme.typography.b2Regular,
  linksty: theme.typography.link2,
  mediumsty: theme.typography.b2Medium,
  h4sty: theme.typography.h4,
});

function QuizSection(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useNavigate();
  const authState = useSelector((state) => state.auth);
  const roleState = useSelector((state) => state.role);
  const theme = useTheme();
  const isNotMobile = useMediaQuery(theme.breakpoints.up("tablet"));
  const [snacktext, setsnacktext] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [reset, setReset] = React.useState(false);
  const [testvalue, setTestvalue] = React.useState("");

  let mappedSkills = [];
  props?.data?.skillMatch?.forEach((skill) => {
    let fullName = props.data.skillsMaster[skill.skill].fullName;

    let mappedSkill = {
      skill: skill.skill,
      fullName: fullName,
      dots: skill.dots,
      points: skill.points,
    };

    mappedSkills.push(mappedSkill);
  });

  const ResetTest = (value) => {
    setReset(true);
    setTestvalue(value);
  };

  const ResetTestsection = () => {
    // FK cleanup unused variable
    let payload = {
      section: testvalue,
      inviteId: props.id,
    };
    dispatch(role.restTestInvite(payload));
  };

  useEffect(() => {
    if (roleState?.resetTest?.status === 0) {
      setOpen(true);
      setsnacktext(roleState?.resetTest?.data);
    }
    // eslint-disable-next-line
  }, [roleState?.resetTest?.status]);

  const handleLink = (link) => {
    history(link);
  };

  const combinevalues = roleState?.invitedetails?.selectedTestingRequirement?.reduce((accumulator, select, index) => {
    return accumulator.concat({
      testingRequired: select,
    });
  }, []);

  const getSortedSkills = useMemo(() => {
    const list =
      authState?.areaOfStrengthsAndImprovements?.Technical?.length > 0
        ? authState?.areaOfStrengthsAndImprovements?.Technical
        : roleState?.invitedetails?.jobRole?.skillDetails;

    if (roleState?.invitedetails?.jobRole?.skillDetails.length > 0) {
      let skillDtls = [...roleState?.invitedetails?.jobRole?.skillDetails];
      list.map((i) => {
        let skillName = i["Topic"] || i["skill"];
        let skill = skillDtls.filter((sk) => sk.skill.toLowerCase() === skillName.toLowerCase());
        // console.log("skill---", skill);
        i["weightage"] = skill[0]["weightage"];
        // i['skill'] = skillName;
        i["skill"] = skill[0]["skillFullName"];
      });
    }

    return list?.sort(function (a, b) {
      return b.weightage - a.weightage || a.skill?.localeCompare(b.skill);
    });
  }, [roleState?.invitedetails?.jobRole?.skillDetails, authState?.areaOfStrengthsAndImprovements?.Technical]);

  return (
    <>
      <div className={classes.scoresCalculatedBy} style={{ marginTop: "30px" }}>
        <ImageList rowHeight={"auto"} cols={isNotMobile ? 2 : 1} gap={16}>
          <ImageListItem>
            <Card
              className={
                props.disabled === true
                  ? `${classes.sectionDisable}`
                  : combinevalues?.[0]?.testingRequired === "Profile" ||
                    combinevalues?.[1]?.testingRequired === "Profile" ||
                    combinevalues?.[2]?.testingRequired === "Profile" ||
                    combinevalues?.[3]?.testingRequired === "Profile"
                  ? classes.scoreCard
                  : classes.scoreCard1
              }
              elevation={0}
            >
              <CardContent sx={{ backgroundColor: "#FFFBF6", height: "100%" }}>
                <Typography
                  variant2="b2Medium"
                  className={`${classes.scoresCalculatedByCardTitle} ${classes.mediumsty}`}
                  align="left"
                >
                  Profile{" "}
                </Typography>
                <Typography variant2="b2Regular" className={classes.grayText} sx={{ fontSize: "14px" }} align="left">
                  This section matches the overall digital profile of a candidate based on the skills and experience
                  described in the resume.
                  <div style={{ marginTop: "25px" }}>
                    <Sections data={props?.data?.profileMatch}></Sections>
                  </div>
                </Typography>
              </CardContent>
            </Card>
          </ImageListItem>

          <ImageListItem>
            <Card
              className={
                props.disabled === true
                  ? `${classes.sectionDisable}`
                  : combinevalues?.[0]?.testingRequired === "Technical" ||
                    combinevalues?.[1]?.testingRequired === "Technical" ||
                    combinevalues?.[2]?.testingRequired === "Technical" ||
                    combinevalues?.[3]?.testingRequired === "Technical"
                  ? classes.scoreCard
                  : classes.scoreCard1
              }
              elevation={0}
            >
              <CardContent sx={{ backgroundColor: "#FFFBF6", height: "100%" }}>
                <Typography
                  variant2="b2Medium"
                  className={`${classes.scoresCalculatedByCardTitle} ${classes.mediumsty}`}
                  align="left"
                >
                  Skill Match
                </Typography>
                <Typography
                  variant2="b2Regular"
                  className={classes.grayText}
                  sx={{ fontSize: "14px" }}
                  align="left"
                  style={theme.typography.b2Regular}
                >
                  This section matches the candidate's skills against the job requirements.
                  <div style={{ marginTop: "25px" }}>
                    <Sections data={mappedSkills}></Sections>
                  </div>
                </Typography>
              </CardContent>
            </Card>
          </ImageListItem>
        </ImageList>
      </div>
      <SimpleSnackbar open={open} setOpen={setOpen} text={snacktext} />
    </>
  );
}
export default QuizSection;
